module.exports = __webpack_public_path__ + "static/media/water4all-co-funded-by-the-eu-vertical.95a2c428.png";